module.exports = __webpack_public_path__ + "img/project_statistics.f0db1caa.png";